import React from 'react';
import { Button, Form, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { inviteBusinessAction, inviteReferrerAction } from '../../actions/refer';
import { useSelector } from 'react-redux';
import Header from '@components/Comman/Header';
import SocialMediaCard from '../SocialMedia/SocialMediaCard';
// @ts-ignore
import { referuspageurl } from '../../environment'
import { SendOutlined, UploadOutlined } from '@ant-design/icons';
import './index.css'
import CustomPhoneNumber from '@components/Comman/CustomPhoneNumber/CustomPhoneNumber';

const InviteBusiness = ({disableHeader, inviteInfo, setAtiveStep}: any) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state?.General?.isLoading);
    const userD = useSelector((state: any) => state?.Auth?.user);
    const userData = userD?.user || userD?.data;
        const businessDetails = useSelector((state: any) => state?.Business?.businessDetails);


    const onFinish = (values: any) => {
        delete values?.businessCode;
        delete values?.businessName;
        values.isBusinessInvite = true
        console.log('Success:', values);
        dispatch(
            inviteBusinessAction(values, (resp: any) => {
                if (resp) {
                  form.resetFields();
                }
            })
        );
    };

    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        // You can also display an error message to the user here
    };

    let url = userData?.roleId === 2 ?  `${referuspageurl}/refer-us/${userData?.businessCode}` : `${referuspageurl}/refer-us/${userData?.referrerCode}`

    let businessData = {
        ...businessDetails,
        business: {
            businessCode: userData?.businessCode,
            BusinessDetails: {
                businessName: userData?.businessDetails?.businessName,
                url: url,
                image: businessDetails?.logoUrl
            }
        },

    }

    return (
      <div>
       {!disableHeader &&
        <Header pagTitle="Build Your Network" />
       }
        <div className='contentBody'>

          <div className={inviteInfo ? "" : "bodycard"}>
       {inviteInfo && 
    <div>
        <b style={{ fontSize: '22px' }}>
            Build your own referral network with businesses you already know.
        </b>
        <div 
            className='d-flex' 
            style={{ 
                flexDirection: 'column', 
                // marginTop: '10px', 
                fontSize: '18px', 
                // lineHeight: '0.5' 
            }}
        >
            <p>
                Invite businesses in seconds, and once they're on ReferUs, you can swap referrals directly – quick, simple, effective. Just fill in the form and select "Send Invite".
            </p>
        </div>
    </div>
}
<br />
            <div className="bodycardheading d-flex csv-header">
              <div>
                <div className="mobileView buttonsvgs" onClick={()=> navigate(-1)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    >
                    <rect
                      x="0.4"
                      y="1.18168"
                      width="23.2"
                      height="23.2"
                      rx="11.6"
                      stroke="#F47523"
                      strokeWidth="0.8"
                    />
                    <path
                      d="M14 8.78168L10 12.7817L14 16.7817"
                      stroke="#F47523"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      />
                  </svg>
                </div>
                Invite a Business
              </div>
              {/* <div>
                <button className='btn btn-primary' onClick={()=> navigate('/upload-referrer')} type='button'> Upload Referrer <UploadOutlined /></button>
                </div> */}
            </div>
                
            <div className="cardContentbody">
              <Form
                className="formControl"
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFailed}
                initialValues={{
                  // businessName: userData?.companyName
                }}
              >
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="Business Name"
                      name="businessName"
                    >
                      <Input placeholder='Business Name' />
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="First Name"
                      name="firstName"
                      rules={[{ required: true, message: 'Please input your First Name!' }]}
                    >
                      <Input placeholder='First Name' />
                    </Form.Item>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="Last Name"
                      name="lastName"
                      rules={[{ required: true, message: 'Please input your Last Name!' }]}
                    >
                      <Input placeholder='Last Name' />
                    </Form.Item>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <Form.Item
                      className="formControlDesign"
                      label="Email"
                      name="email"
                      rules={[{ required: true, type: 'email', message: 'Please input a valid email!' }]}
                    >
                      <Input placeholder='Email' />
                    </Form.Item>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <CustomPhoneNumber isRequired={true} label="Contact Number" name="mobileNumber" />
                  </div>
                 
                  {/* <div className="w-100 mt-15 d-flex justify-content-end"> */}
                    <div className="w-100 mt-15 d-flex" style={{justifyContent: "end", gap: "10px", flexWrap: "wrap"}}>

                      <div>
                      <button className="btn btn-outline-primary" onClick={() => navigate('/dashboard')}>
                        Cancel
                      </button>
                      </div>
                      <div>
                      <Button className="btn btn-primary" loading={isLoading} type='primary' onClick={() => form.submit()}>
                        Send Invite <SendOutlined />
                      </Button>

                      </div>
                     <div>
                      {/* {inviteInfo && */}
                      <Button className="btn btn-primary" type='primary' onClick={() => navigate('/dashboard')}>
                        Finish <SendOutlined />
                      </Button>
                      {/* } */}
                      </div>
                    </div>
                  {/* </div> */}
                </div>
              </Form>
              <div className='mt-15'>
                                <SocialMediaCard extraTitle showQr={false} isPersonalBusiness={true} topTitle="Promote ReferUs to your network" userData={userData} userRole={userData?.roleId} className="social-media-card" isRefer={true} data={businessData} key={0} />
                            </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default InviteBusiness;
